import { DefinedPropertyObject, IEntityMinimalModel } from "../../../api/GenericTypes";
import { LabNotebookTemplate, LabNotebookTemplateFilters } from "../../types/LabNotebookTemplate";
import {
  TabStoreFilterSidebarProps,
  TabStoreFilterFormProvider,
} from "../../../common/sidebar/filtersidebar/TabStoreFilterFormProvider";
import { EntityFilterSideBar } from "../../../common/sidebar/filtersidebar/EntityFilterBar";
import { ProjectsVirtualizedSelectForm } from "../../../common/forms/EntityForms/formsVirtualized/ProjectsVirtualizedSelectForm";
import {
  CombinedModificationRecordEntityDefaultFormValues,
  combinedModificationRecordEntityFiltersToForm,
  combinedModificationRecordEntityFormToFilters,
  ICombinedModificationRecordEntityForm,
} from "../../../common/sidebar/filtersidebar/GenericFilters/CombinedModificationRecordEntityFilterFormModels";
import {
  ISoftDeletableEntityForm,
  SoftDeletableEntityDefaultFilterFormValues,
  softDeletableEntityFiltersToForm,
  softDeletableEntityFormToFilters,
} from "../../../common/sidebar/filtersidebar/GenericFilters/SoftDeletableEntityFilterFormModels";
import { CombinedModificationRecordEntityFilterForm } from "../../../common/sidebar/filtersidebar/GenericFilters/CombinedModificationRecordEntityFilterForm";
import { defaultLabNotebookTemplatesFiltersFilter } from "./LabNotebookTemplatesTable";

export interface LabNotebookTemplateFilterForm extends ICombinedModificationRecordEntityForm, ISoftDeletableEntityForm {
  projectIds?: IEntityMinimalModel[] | undefined | null;
}
const defaultValues: DefinedPropertyObject<LabNotebookTemplateFilterForm> = {
  projectIds: null,
  ...CombinedModificationRecordEntityDefaultFormValues,
  ...SoftDeletableEntityDefaultFilterFormValues,
};
export const labNotebookTemplatesFormToFilters = (form: LabNotebookTemplateFilterForm): LabNotebookTemplateFilters => {
  let filters: LabNotebookTemplateFilters = {
    ...combinedModificationRecordEntityFormToFilters(form),
    ...softDeletableEntityFormToFilters(form),
  };
  filters.projectIds =
    Array.isArray(form.projectIds) && form.projectIds.length > 0 ? form.projectIds?.map((d) => d.id) : null;
  return filters;
};

/**
 * Converts LabNotebookTemplateFilters to LabNotebookTemplateFilterForm
 * @param filters LabNotebookTemplateFilters
 * @returns LabNotebookTemplateFilterForm
 * @author @CorradoSurmanowicz
 */
export const labNotebookTemplatesFiltersToForm = (
  filters: LabNotebookTemplateFilters
): LabNotebookTemplateFilterForm => {
  return {
    projectIds: filters.projectIds ? filters.projectIds.map((id) => ({ id, name: "" })) : null,
    ...combinedModificationRecordEntityFiltersToForm(filters),
    ...softDeletableEntityFiltersToForm(filters),
  };
};

export const LabNotebookTemplateFilterBar = ({
  initialValues,
  onFormChange,
  dispatchTabStore,
  tabsLoading,
  currentTab,
}: TabStoreFilterSidebarProps<LabNotebookTemplate, LabNotebookTemplateFilterForm, LabNotebookTemplateFilters>) => {
  return (
    <TabStoreFilterFormProvider
      tabsLoading={tabsLoading}
      initialValues={initialValues}
      defaultValues={defaultValues}
      defaultFilters={defaultLabNotebookTemplatesFiltersFilter}
      formToFilters={labNotebookTemplatesFormToFilters}
      onFormChange={onFormChange}
      dispatchTabStore={dispatchTabStore}
    >
      {({ control, onReset }) => (
        <EntityFilterSideBar onReset={onReset}>
          <ProjectsVirtualizedSelectForm id="projectIds" control={control} isMulti />

          <CombinedModificationRecordEntityFilterForm
            control={control}
            currentTab={currentTab}
            initialValues={initialValues}
          />

          {/* <SoftDeletableEntityFilterForm control={control} currentTab={currentTab} initialValues={initialValues} /> */}
        </EntityFilterSideBar>
      )}
    </TabStoreFilterFormProvider>
  );
};
